(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["kilua-ktor-mongo"] = factory();
	else
		root["kilua-ktor-mongo"] = factory();
})(globalThis, () => {
return 